export default __webpack_public_path__ + "static/media/ShipporiMincho-Medium.be3debf5.ttf";